const initialState = {
  Data: [],
  loading: false,
  error: null,
  IwoGroupData: [],
  iwoGroupLoading: false, 
  JobHoursData: [],
  jobHoursLoading: false,
};

export const AccumulateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_PRODUCTION_ACCUMULATED_REQUEST":
      return { ...state, loading: true };
    case "FETCH_PRODUCTION_ACCUMULATED_SUCCESS":
      return { ...state, Data: action.payload, loading: false };
    case "FETCH_PRODUCTION_ACCUMULATED_FAILURE":
      return { ...state, error: action.payload, loading: false };
    case "FETCH_IWO_GROUP_BY_ADDITIONAL_REQUEST":
      return { ...state, iwoGroupLoading: true };
    case "FETCH_IWO_GROUP_BY_ADDITIONAL_SUCCESS":
      return { ...state, IwoGroupData: action.payload, iwoGroupLoading: false };
    case "FETCH_IWO_GROUP_BY_ADDITIONAL_FAILURE":
      return { ...state, error: action.payload, iwoGroupLoading: false };

    case "FETCH_JOB_HOURS_REQUEST":
      return { ...state, jobHoursLoading: true };
    case "FETCH_JOB_HOURS_SUCCESS":
      return { ...state, JobHoursData: action.payload, jobHoursLoading: false };
    case "FETCH_JOB_HOURS_FAILURE":
      return { ...state, error: action.payload, jobHoursLoading: false };

    default:
      return state;
  }
};